
// 🚀 RESTORE POINT: 80 VOGLIA APP - VERSION V102.2 - RESTORE POINT CREATED
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './src/i18n'; // Import i18n
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './src/queryClient';
import { APP_VERSION } from './version';

console.log(`Starting App Version: ${APP_VERSION}`);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Service Worker Registration, for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

import { DialogProvider } from './context/DialogContext';

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DialogProvider>
        <App />
      </DialogProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
